import { render } from "./NewOrder.vue?vue&type=template&id=4308ba4e&scoped=true&ts=true"
import script from "./NewOrder.vue?vue&type=script&lang=ts"
export * from "./NewOrder.vue?vue&type=script&lang=ts"

import "./NewOrder.vue?vue&type=style&index=0&id=4308ba4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4308ba4e"]])

export default __exports__